const link_creator_form = 'linkCreatorForm';

export default {
  link_creator_form,
};



// WEBPACK FOOTER //
// ./src/app/main/link-creator/constants/link-creator-constants.js